import { createContext, useContext, useMemo, useState } from "react";

const ProductCategoriesValueContext = createContext();
const ProductCategoriesActionsContext = createContext();

export function ProductCategoriesContextProvider({ children }) {
    const [productCategories, setProductCategories] = useState(null);

    const productCategoriesActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setProductCategories(newValues);
                },
                setValue: setProductCategories
            }
        },
        []
    )

    return (
        <>
            <ProductCategoriesActionsContext.Provider value={{ productCategories: productCategoriesActions }}>
                <ProductCategoriesValueContext.Provider value={{ productCategories }}>
                    {children}
                </ProductCategoriesValueContext.Provider>
            </ProductCategoriesActionsContext.Provider>
        </>
    );
}

export function useProductCategoriesValueContextHook(props) {
    const value = useContext(ProductCategoriesValueContext);

    if (value === undefined) {
        throw new Error('useProductCategoriesValueContextHook should be used within ProductCategoriesValueContext');
    }

    return {
        productCategories: value.productCategories,
    };
}

export function useProductCategoriesActionsContextHook(props) {
    const value = useContext(ProductCategoriesActionsContext);

    if (value === undefined) {
        throw new Error('useProductCategoriesActionsContextHook should be used within ProductCategoriesActionsContext');
    }

    return {
        productCategories: {
            onSet: value.productCategories.onSet,
            setValue: value.productCategories.setValue
        },
    };
}